export const DASHBOARD_BUSINESS_UNIT_SUB_TABS_SECTION_DAID = 'business-unit-sub-tabs-section';
export const DASHBOARD_BUSINESS_UNIT_TABS_DAID = 'business-unit-tabs';
